package dev.mft.website.composable.footer

import androidx.compose.foundation.Image
import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.*
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.layout.ContentScale
import androidx.compose.ui.platform.UriHandler
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import dev.mft.website.classes.Social
import mft_website.composeapp.generated.resources.Res
import mft_website.composeapp.generated.resources.github
import mft_website.composeapp.generated.resources.instagram
import mft_website.composeapp.generated.resources.linkedin
import org.jetbrains.compose.resources.painterResource

val github = Social(
    resourceId = Res.drawable.github,
    contentDescription = "GitHub",
    url = "https://github.com/FrigoTurcoMoreno"
)

val socials = listOf(
    Social(
        resourceId = Res.drawable.linkedin,
        contentDescription = "LinkedIn",
        url = "https://linkedin.com/in/moreno-frigo-turco-4a423a294"
    ),
    Social(
        resourceId = Res.drawable.instagram,
        contentDescription = "Instagram",
        url = "https://instagram.com/morenofrigo.dev"
    )
)

@Composable
fun Contact(
    modifierBox: Modifier,
    uriHandler: UriHandler,
    fontSize: Float,
    imageSize: Float
) {
    BoxWithConstraints(
        modifier = modifierBox
    ) {
        val calculatedImageSize = minOf(maxWidth, maxHeight) * imageSize
        val calculatedTitleSize = (maxHeight.value * fontSize).sp

        Column (
            modifier = Modifier
                .fillMaxSize(),
            verticalArrangement = Arrangement.SpaceEvenly,
            horizontalAlignment = Alignment.CenterHorizontally
        ) {
            Text(
                "Contact me here...",
                fontSize = calculatedTitleSize,
                fontWeight = FontWeight.Bold,
                textAlign = TextAlign.Center
            )
            Row(
                horizontalArrangement = Arrangement.spacedBy(24.dp),
                verticalAlignment = Alignment.CenterVertically
            ) {
                socials.forEach { social ->
                    Box(
                        modifier = Modifier
                            .size(calculatedImageSize)  // ← Usa la dimensione calcolata
                            .clickable {
                                uriHandler.openUri(social.url)
                            },
                    ) {
                        Image(
                            modifier = Modifier.fillMaxSize(),
                            painter = painterResource(social.resourceId),
                            contentDescription = social.contentDescription,
                            contentScale = ContentScale.Fit,  // ← Cambiato da Crop a Fit
                        )
                    }
                }
            }

            Text(
                "...or see my repos!",
                fontSize = calculatedTitleSize,
                fontWeight = FontWeight.Bold,
                textAlign = TextAlign.Center
            )
            Row(
                horizontalArrangement = Arrangement.Center,
                verticalAlignment = Alignment.CenterVertically
            ) {
                Box(
                    modifier = Modifier
                        .size(calculatedImageSize)  // ← Usa la dimensione calcolata
                        .clickable {
                            uriHandler.openUri(github.url)
                        },
                ) {
                    Image(
                        modifier = Modifier.fillMaxSize(),
                        painter = painterResource(github.resourceId),
                        contentDescription = github.contentDescription,
                        contentScale = ContentScale.Fit,  // ← Cambiato da Crop a Fit
                    )
                }
            }
        }
    }
}